<template>
  <div v-if="datas" class="node-children">
    <div v-if="datas.parent_id === 0" class="node-label root-label">
      <img class="root-img1" src="../assets/root-img.png" alt="">
      <img class="root-img2" src="../assets/root-img2.png" alt="">
    </div>
    <div v-else class="node-label" @click="select(datas)">
      <div class="photo" :style="{'background-image': 'url(' + BG_IMG(datas.img_url || 'upload/default.jpg') + ')'}"></div>
      <p v-if="datas.word_name">{{datas.word_name}}</p>
    </div>
    <div v-if="datas.children && datas.children.length" class="tree-node">
      <tree-node
        v-for="item in datas.children"
        :key="item.id"
        :datas="item"
        :select="select">
      </tree-node>
    </div>
  </div>
</template>


<script>
  import config from '../config'

  export default {
    props: ['datas', 'select'],
    name : 'tree-node',
    methods: {
      BG_IMG (val) {
        if(val){
          return config.fileManagerPrefix + val
        }else{
          return ''
        }
      },
    }
  }
</script>

<style lang="less">
  @dis: 20px;
  @bdColor: #bc8129;
  @bdWidth: 2px;

  .horizontal{
    .root-img1{
      display: block;
    }
    .root-img2{
      display: none;
    }
  }
  .vertical{
    .root-img1{
      display: none;
    }
    .root-img2{
      display: block;
    }
  }

  .horizontal {
    > .node-children {
      &:before {
        display: none;
      }
    }
    .node-children {
      //float: left;
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: @dis;

      &:before,
      &:after {
        position: absolute;
        left: -@bdWidth;
        width: @dis;
        height: 50%;
        border-left: @bdWidth @bdColor solid;
        content: "";
      }
      &:before {
        top: 0;
        border-bottom: @bdWidth @bdColor solid;
      }
      &:after {
        bottom: 0;
      }
      &:first-child {
        &:before {
          border-left-color: transparent;
        }
      }
      &:last-child {
        &:after {
          border-left-color: transparent;
        }
      }
    }
    .tree-node {
      padding-left: @dis;
      display: block;
    }
    .node-label {
      position: relative;
      padding: 5px 0;
      transform: translateY(5px);
      cursor: pointer;

      &:before {
        position: absolute;
        right: -@dis;
        width: @dis;
        height: @bdWidth;
        top: 50%;
        transform: translateY(-7px);
        border-top: @bdWidth @bdColor solid;
        content: "";
      }

      &:only-child {
        &:before {
          display: none;
        }
      }

      &:hover {
        .photo {
          transform: scale(2);
        }
      }

      .photo {
        position: relative;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: url(../assets/photo.jpg) center no-repeat;
        background-size: cover;
        box-shadow: 3px 3px 0 #bb8c43;
        transition: all .2s ease-out;
        transform-origin: center bottom;
        z-index: 1;
      }

      p {
        margin-top: 3px;
        text-align: center;
        color: #000000;

      }
    }
  }

  .vertical {
    text-align: center;

    > .node-children {
      padding: 0 20px;

      &:before {
        display: none;
      }
    }

    .node-children {
      position: relative;
      flex-direction: column;
      padding-top: @dis;
      float: left;

      &:before,
      &:after {
        position: absolute;
        top: -@bdWidth;
        height: @dis;
        width: 50%;
        border-top: @bdWidth @bdColor solid;
        content: "";
      }
      &:before {
        left: 0;
        border-right: @bdWidth @bdColor solid;
      }
      &:after {
        right: 0;
      }
      &:first-child {
        &:before {
          border-top-color: transparent;
        }
      }
      &:last-child {
        &:after {
          border-top-color: transparent;
        }
      }
    }
    .tree-node {
      padding-top: @dis;
      display: flex;
      //float: left;
      //justify-content: center;
      //align-items: flex-start;
    }
    .node-label {
      display: inline-block;
      position: relative;
      margin: 0 5px;
      cursor: pointer;
      &:before {
        position: absolute;
        bottom: -@dis;
        height: @dis;
        width: @bdWidth;
        left: 50%;
        border-left: @bdWidth @bdColor solid;
        transform: translateX(-2px);
        content: "";
      }

      &:only-child {
        &:before {
          display: none;
        }
      }

      &:hover {
        .photo {
          transform: scale(2);
        }
      }

      .photo {
        display: none;
        position: relative;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        //background: url(../assets/photo.jpg) center no-repeat;
        background-size: cover;
        box-shadow: 3px 3px 0 #bb8c43;
        transition: all .2s ease-out;
        transform-origin: center bottom;
        z-index: 1;
      }

      p {
        width: 24px;
        height: 50px;
        text-align: center;
        color: #000000;
        line-height: 1;
        font-size: 20px;
        font-weight: 600;
      }
    }
  }

  @media (min-width:768px){
    .vertical{



      .node-label {
        margin: 0 5px;
        .photo{
          display: block;
        }
        p{
          margin-top: 5px;
          font-size: 14px;
          height: 42px;
          font-weight: 400;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/tree-node.vue